/* Canvas Galore — front-end behaviour
   - Countdown timer for [data-cg-countdown]
   - Mobile menu toggle
   - Exit-intent modal (fixed SAVE10 code)
   - Live cart count update
*/
(function () {
  'use strict';

  /* ---------- Countdown ---------- */
  // Returns end of THIS month 23:59:59 in Cape Town (SAST = UTC+2, no DST).
  // When the month ends it automatically targets the next month's last day.
  function cgEndOfMonthEodSast() {
    var sastNow = new Date(Date.now() + 2 * 3600 * 1000);
    var y = sastNow.getUTCFullYear(), mo = sastNow.getUTCMonth();
    // day 0 of (mo+1) === last day of month mo. 23:59:59 SAST == 21:59:59 UTC.
    var end = Date.UTC(y, mo + 1, 0, 21, 59, 59);
    if (end - Date.now() <= 0) {
      end = Date.UTC(y, mo + 2, 0, 21, 59, 59); // roll to next month's last day
    }
    // October promotion is already live; November onward keeps the monthly rollover.
    return Math.max(end, Date.UTC(2026, 9, 31, 21, 59, 59));
  }

  // Tolerant deadline parser. Empty / "auto" / "month" → end of this month EOD SAST.
  function cgParseDeadline(raw) {
    if (!raw) return cgEndOfMonthEodSast();
    var s = String(raw).trim().toLowerCase();
    if (!s || s === 'auto' || s === 'month' || s === 'month-end' || s === 'end-of-month' || s === 'sunday' || s === 'next-sunday') {
      return cgEndOfMonthEodSast();
    }
    // ISO / date string handling
    var orig = String(raw).trim();
    var hasTz = /[zZ]$|[+\-]\d{2}:?\d{2}$/.test(orig);
    orig = orig.replace(' ', 'T');
    if (/^\d{4}-\d{2}-\d{2}$/.test(orig)) orig += 'T23:59:59';
    if (!hasTz) orig += '+02:00';
    var t = new Date(orig).getTime();
    return isNaN(t) ? cgEndOfMonthEodSast() : t;
  }

  document.querySelectorAll('[data-cg-offer-deadline]').forEach(function (el) {
    el.textContent = 'Current specials · Ends ' + new Date(cgEndOfMonthEodSast()).toLocaleDateString('en-ZA', { day: 'numeric', month: 'long', timeZone: 'Africa/Johannesburg' });
  });

  document.querySelectorAll('[data-cg-countdown]').forEach(function (el) {
   try {
    var deadline = cgParseDeadline(el.getAttribute('data-cg-countdown'));
    var dEl = el.querySelector('[data-d]');
    var hEl = el.querySelector('[data-h]');
    var mEl = el.querySelector('[data-m]');
    var sEl = el.querySelector('[data-s]');
    function pad(n) { return String(n).padStart(2, '0'); }
    function tick() {
      var diff = deadline - Date.now();
      if (diff <= 0) {
        // Auto-roll to the next month's end immediately
        deadline = cgEndOfMonthEodSast();
        diff = deadline - Date.now();
      }
      var d = Math.floor(diff / 86400000);
      var h = Math.floor((diff % 86400000) / 3600000);
      var m = Math.floor((diff % 3600000) / 60000);
      var s = Math.floor((diff % 60000) / 1000);
      if (dEl) dEl.textContent = d;
      if (hEl) hEl.textContent = pad(h);
      if (mEl) mEl.textContent = pad(m);
      if (sEl) sEl.textContent = pad(s);
    }
    tick();
    setInterval(tick, 1000);
   } catch (err) { /* never let the countdown break other scripts */ }
  });

  /* ---------- Mobile menu ----------
     Handled by a self-contained script inside cg-header.liquid so it always
     works even if this file errors. (Intentionally not duplicated here to
     avoid a double-toggle that would cancel the open/close.) */

  /* ---------- Cart count ---------- */
  function refreshCart() {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      document.querySelectorAll('[data-cg-cart-count]').forEach(function (n) {
        n.textContent = (cart.items || []).reduce(function (count, item) {
          return count + (item.handle === 'wrap-upgrade' || item.handle === 'canvas-wrap-fee' || item.handle === 'urgent-production-fee' ? 0 : item.quantity);
        }, 0);
      });
    }).catch(function () { /* noop */ });
  }
  refreshCart();
  document.addEventListener('cg:cart-changed', refreshCart);

  /* ---------- Exit-intent (fixed SAVE10 code) ---------- */
  var exit = document.querySelector('[data-cg-exit]');
  if (exit) {
    var STORAGE_KEY = 'cg-exit-shown-v1';
    var VOUCHER_KEY = 'cg-exit-voucher';
    function open() {
      if (localStorage.getItem(STORAGE_KEY)) return;
      exit.classList.add('is-open');
      localStorage.setItem(STORAGE_KEY, '1');
    }
    document.addEventListener('mouseleave', function (e) {
      if (e.clientY <= 0) open();
    });
    setTimeout(open, 90000); // also trigger after 90s of dwell
    exit.addEventListener('click', function (e) {
      if (e.target === exit) exit.classList.remove('is-open');
    });
    exit.querySelectorAll('[data-cg-exit-close]').forEach(function (b) {
      b.addEventListener('click', function () { exit.classList.remove('is-open'); });
    });
    var form = exit.querySelector('[data-cg-exit-form]');
    var errEl = exit.querySelector('[data-cg-exit-error]');
    var codeEl = exit.querySelector('[data-cg-exit-code]');
    var fixedCode = exit.getAttribute('data-voucher-code') || 'SAVE10';
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var email = form.querySelector('input[type="email"]').value.trim();
        if (!email || email.indexOf('@') === -1) {
          if (errEl) { errEl.textContent = "That email doesn't look right."; errEl.classList.add('is-visible'); }
          return;
        }
        if (errEl) errEl.classList.remove('is-visible');
        localStorage.setItem(VOUCHER_KEY, fixedCode);
        if (codeEl) codeEl.querySelector('span').textContent = fixedCode;
        exit.classList.add('is-success');
        var shopifyEmail  = exit.querySelector('[data-cg-exit-shopify-email]');
        var shopifySubmit = exit.querySelector('[data-cg-exit-shopify-submit]');
        if (shopifyEmail && shopifySubmit) {
          shopifyEmail.value = email;
          try { shopifySubmit.click(); } catch (_) {}
        }
      });
    }
    if (codeEl) {
      codeEl.addEventListener('click', function () {
        var txt = codeEl.querySelector('span').textContent;
        if (navigator.clipboard) navigator.clipboard.writeText(txt);
        var ic = codeEl.querySelector('[data-cg-exit-copy-ic]');
        if (ic) {
          ic.textContent = '✓';
          setTimeout(function () { ic.textContent = '⧉'; }, 1800);
        }
      });
    }
  }

  /* ---------- Smooth-scroll for #anchors ---------- */
  document.querySelectorAll('a[href^="#"]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      var id = a.getAttribute('href');
      if (id.length < 2) return;
      var target = document.querySelector(id);
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

  /* ---------- Buy Now (product cards across the site) ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-cg-buy-now]');
    if (!btn) return;
    e.preventDefault();
    var id = btn.getAttribute('data-variant-id');
    if (!id) return;
    var variantId = parseInt(id, 10);
    var orig = btn.innerHTML;
    btn.innerHTML = 'Adding…';
    btn.disabled = true;

    // Look at the current cart first — if this variant is already there at qty >= 1,
    // skip the add (otherwise Shopify increments qty and the customer ends up with 2).
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var existing = (cart.items || []).find(function (it) { return it.variant_id === variantId; });
        if (existing) return null; // already there — just continue to checkout
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 })
        }).then(function (r) { return r.json().then(function (b) { return { ok: r.ok, data: b }; }); })
          .then(function (res) {
            if (!res.ok) throw new Error((res.data && res.data.description) || 'Could not add to cart');
            return res;
          });
      })
      .then(function () {
        btn.innerHTML = 'Going to checkout…';
        window.location.href = '/checkout';
      })
      .catch(function (err) {
        btn.innerHTML = orig;
        btn.disabled = false;
        alert(err.message);
      });
  });

})();
